import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-more\"><path d=\"M512 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM512 576a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM576 832a64 64 0 1 1-128 0 64 64 0 0 1 128 0z\" fill=\"#000000\" fill-opacity=\".9\" p-id=\"4263\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol